module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_vestfold_telemark_neg.43fb065a.svg";